import { apiInstance } from ".";

export const postUserNickname = async (nickname: string) => {
  const url = '/user/info/nickname';
  return apiInstance.post(url, {
    nickname: nickname
  })
  .then(res => res)
  .catch(err => err.response || err)
}